<template>
    <div :class="['interaction',{ interactionFull:isFull }]">
        <div class="tab-header">
            <p
                v-for="(item,index) in tabList"
                :key="index"
                :class="['tab-message',currenIndex === index ? 'active' : '']"
                @click="setTab(index)"
                v-show="isFull ? index <= 1 : index >= 0"
            >
                {{TabCardCurrent !== 0 && index === 0 ? '老师' : item}}
                <img
                    v-if="index === 0"
                    class="icon"
                    :src="showTabCard ? UPICON : DOWNICON"
                    alt=""
                >
            </p>
        </div>
        <div class="tab-card" v-show="showTabCard">
            <p
                v-for="(item,index) in tabCardList"
                :key="index"
                @click="setTabCard(index)"
                :class="{ active: TabCardCurrent === index }"
            >
                <span>{{item}}</span>
            </p>
        </div>
        <div class="tab-body" >
            <Advertising
              :class="{adFull:isFull}"
              v-if="RecommendCourse.imagesH5"
              :RecommendCourse="RecommendCourse"
              @destroyLiveRoom="$emit('destroyLiveRoom')"
            />
            <Chat
                ref="chat"
                v-show="currenIndex === 0"
                :TabCardCurrent='TabCardCurrent'
                :isFull="isFull"
            />
            <Notice v-show="currenIndex === 1"></Notice>
            <RecommendCourse v-if="currenIndex === 2"></RecommendCourse>
        </div>
    </div>
</template>
<script>
import Chat from './chat.vue';
import Notice from './notice.vue';
import RecommendCourse from '../../live/components/recommendCourse.vue';
import Advertising from '../../live/components/advertising.vue';

export default {
  name: 'interactionPanel',
  props: ['RecommendCourse', 'isFull'],
  components: {
    Chat,
    Notice,
    RecommendCourse,
    Advertising,
  },
  data() {
    return {
      tabList: ['讨论区', '公告', '推荐'],
      currenIndex: 0,
      tabCardList: ['全部讨论', '仅看老师'],
      showTabCard: false,
      TabCardCurrent: 0,
      DOWNICON: require('../../../assets/img/live/down.png'),
      UPICON: require('../../../assets/img/live/up.png'),
      CHECKEDICON: require('../../../assets/img/live/checked.png'),
    };
  },
  watch: {
    isFull() {
      if (this.currenIndex === 2) {
        this.currenIndex = 0;
      }
    },
  },
  methods: {
    //   讨论区 公告 推荐
    setTab(index) {
      if (this.currenIndex === 0 && index === 0) {
        this.showTabCard = !this.showTabCard;
        return;
      }
      this.currenIndex = index;
      if (index > 0) {
        this.showTabCard = false;
      }
      if (this.currenIndex === 0) this.$refs.chat.chatHeight();
    },
    // 全部讨论 仅看老师
    setTabCard(index) {
      this.TabCardCurrent = index;
      this.showTabCard = false;
      this.$refs.chat.chatHeight();
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss">
    .interaction {
        position: absolute;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .tab-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 30px 0;
            font-size: 32px;
            background: #fff;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);

            p {
                position: relative;
                display: inline-block;
                // flex-grow: 1;
                flex: 1;
                box-sizing: border-box;
                text-align: center;
                border-right: 1px solid #E1E1E1;
            }
            p:last-child {
                border-right: none;
            }

            p.active::after {
                position: absolute;
                bottom: -20px;
                left: 50%;
                width: 50px;
                height: 6px;
                background: #FF6C02;
                border-right: 3px;
                border-radius: 10px 10px 0 0;
                transform: translateX(-50%);
                content: '';
            }
        }
        .tab-card {
            position: absolute;
            top:95px;
            z-index: 11 !important;
            width: 100%;
            padding: 20px 80px;
            background: #FFF8F2;
            p {
                position: relative;
                width: 100%;
                padding: 20px;
                span {
                  position: relative;
                  font-size: 29px;
                }

            }
        }
        .icon {
            position: absolute;
            top: 50%;
            width: 32px;
            height: 32px;
            transform: translateY(-50%);
        }
        .active {
            color: #FF6C02;
            span::after {
              position: absolute;
              top: 0;
              right: -35px;
              width: 32px;
              height: 32px;
              background: url('../../../assets/img/live/checked.png') no-repeat;
              background-size: 100% 100%;
              content: '';
          }
        }
          .tab-body {
            position: relative;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            width: 100%;
            height: 100%;
            overflow: hidden;
            .adFull {
              height: 100px;
              img {
                height: 100px;
              }
            }
        }
        &.interactionFull {
          .tab-card {
            padding: 0;
            transform: translateZ(100px);
          }
        }
    }
</style>
